import React, { forwardRef, useEffect, useState } from "react";
import { Dropdown } from "artisn-ui-react";
import { FieldValues } from "react-hook-form";

import Styles from "./FormDropdown.styles";
import { FormDropdownProps as Props } from "./FormDropdown.types";
import { CONSTANTS } from "config/constants";
import useWindowSize from "hooks/useWindowSize";
import { DropdownOverlayStyled } from "./FormDropdown.styles";

import ArrowBottomSVG from "../../../../public/assets/images/anefi/arrow-bottom.svg";
import SeacrhIconSVG from "../../../../public/assets/images/anefi/search-icon.svg";

const { BREAKPOINTS } = CONSTANTS;
const { tablet } = BREAKPOINTS;

const FormDropdown = forwardRef<HTMLSelectElement, Props<FieldValues>>(
  (props, ref) => {
    const { className, placeholder, label, errorMessage, defaultOption } =
      props;
    const { defaultValue, selectData, onChange } = props;
    const { availWidth, width } = useWindowSize();
    const isMobile = width <= tablet;
    const [optionSelected, setOptionSelected] = useState("");
    const [codeOption, setCodeOption] = useState(defaultValue ?? "");
    const [searchValue, setSearchValue] = useState("");

    const selectValue = (value: string, key: string) => {
      setOptionSelected(value);
      setCodeOption(key);
    };

    useEffect(() => {
      if (!codeOption) return;
      onChange?.(codeOption);
    }, [codeOption, onChange]);

    useEffect(() => {
      if (!defaultOption) return;
      setOptionSelected(defaultOption);
    }, [defaultOption]);

    const buttonNode = (
      <div className="FormDropdown__container">
        <p className="FormDropdown__title">
          {optionSelected !== "" ? optionSelected : placeholder}
        </p>
        <ArrowBottomSVG className="FormDropdown__arrow" />
      </div>
    );

    const overlayNode = (
      <DropdownOverlayStyled className="DropdownOverlay" width={availWidth}>
        <div className="DropdownOverlay__top">
          <p className="DropdownOverlay__title">{label}</p>
          <div className="DropdownOverlay__searchBar">
            <input
              className="DropdownOverlay__search"
              autoFocus
              placeholder="Buscar..."
              onChange={e => {
                setSearchValue(e.target.value);
              }}
              value={searchValue}
            />
            <SeacrhIconSVG className="DropdownOverlay__searchIcon" />
          </div>
        </div>
        {selectData
          ?.filter(data => data.value.includes(searchValue))
          .map(item => {
            const { value, key } = item;

            return (
              <p
                className="DropdownOverlay__text"
                key={key}
                onClick={() => selectValue(value, key)}
              >
                {value}
              </p>
            );
          })}
      </DropdownOverlayStyled>
    );

    return (
      <Styles className={`FormDropdown ${className}`}>
        <p className="FormDropdown__label">{label}</p>
        <Dropdown
          className="FormDropdown__dropdown"
          overlay={overlayNode}
          target={["click"]}
          position={isMobile ? "right" : "left"}
          isFixed
        >
          {buttonNode}
        </Dropdown>
        {errorMessage ? (
          <p className="FormDropdown__error">{errorMessage}</p>
        ) : null}
      </Styles>
    );
  }
);

FormDropdown.defaultProps = {
  className: ""
};
FormDropdown.displayName = "FormDropdown";

export default FormDropdown;
